import React from "react";

function StripeCardComponent() {
  return [
    <div id="card-element" sz="large" />,
    <div id="card-errors" className="card-errors" role="alert" />,
  ];
}

export default StripeCardComponent;
